/* global axios */
import ApiClient from './ApiClient';

class InboxMembers extends ApiClient {
  constructor() {
    super('inbox_members', { accountScoped: true });
  }

  update({ inboxId, agentList }) {
    return axios.patch(`${this.url}/${inboxId}`, {
      user_ids: agentList,
    });
  }

  create({ inboxId, agentList }) {
    return axios.post(this.url, {
      inbox_id: inboxId,
      user_ids: agentList,
    });
  }

  destroy({ inboxId, agentList }) {
    return axios.delete(`${this.url}/${inboxId}`, {
      data: {
        user_ids: agentList,
      },
    });
  }
}

export default new InboxMembers();
